import { Dropdown } from 'antd';
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { trackButtonClick } from '../../analytics/mixpanel';
import { ToggleIcon } from '../../assets';
import AngleRightOutlined from '../../assets/docchat/AngleRightOutlined';
import DownCaretIcon from '../../assets/DownCaretIcon';
import HelpCenter from '../../assets/HelpCenterIcon';
import HelpCenterIcon3 from '../../assets/HelpCenterIcon3';
import LogOutIcon from '../../assets/LogOutIcon';
import ProfileIcon from '../../assets/ProfileIcon';
import ProfileIcon2 from '../../assets/ProfileIcon2';
import SettingIcon from '../../assets/SettingIcon';
import { DOC_CHAT } from '../../Constants/commonConstants';
import { useTakeTour } from '../../Features/TakeTour/hooks/useTakeTour';
import FAQ from '../FAQ/FAQ';
import LogoutModal from './LogoutModal';

const initialModalData = { logout: false, faq: false };

function Profile({ name, product }) {
  const [modalData, setModalData] = useState(initialModalData);
  const { dropdownAndMiscStates } = useTakeTour();

  const location = useLocation();

  const handleModal = (key) => {
    setModalData((prev) => ({ ...prev, [key]: true }));
  };

  const closeModal = () => {
    setModalData({ ...initialModalData });
  };

  const helpCenterItems = [
    // {
    //   label: (
    //     <button
    //       onClick={() => {
    //         const flag = location.pathname.includes('/viewer')
    //           ? 'isCompareTourCompleted'
    //           : 'isDashboardTourCompleted';
    //         trackButtonClick({
    //           type: 'Dashboard Take Tour',
    //         });
    //         localStorage.setItem(flag, 'false');
    //         // takeTourStatus(false);
    //         // takeTourTriggered(true);
    //       }}
    //       className="nav-profile-item"
    //     >
    //       Take Tour
    //     </button>
    //   ),
    //   key: '3-1',
    // },
    {
      label: (
        <button
          onClick={() => {
            trackButtonClick({
              type: 'FAQ',
              route: location.pathname,
            });
            handleModal('faq');
          }}
          className='nav-profile-item'
        >
          <HelpCenterIcon3 color='#465364' />
          FAQ&apos;s
        </button>
      ),
      key: '3-2',
    },
  ];

  const items = [
    {
      label: (
        <Link
          to={`/settings/${product === DOC_CHAT ? 'docchat' : 'doccompare'}`}
          className='nav-profile-item'
        >
          <ProfileIcon2 />
          Profile
        </Link>
      ),
      key: '0',
    },
    {
      label: (
        <Link to='/products' className='nav-profile-item'>
          <ToggleIcon />
          Switch Product
        </Link>
      ),
      key: '1',
    },
    {
      label: (
        <Link
          to={`/settings/${product === DOC_CHAT ? 'docchat' : 'doccompare'}`}
          className='nav-profile-item'
        >
          <SettingIcon />
          Settings
        </Link>
      ),
      key: '2',
    },
    {
      label: (
        <span className='nav-profile-item'>
          <HelpCenter />
          <span style={{ margin: '0 6px 0 3px', flex: 1 }}>Help Center</span>
          <AngleRightOutlined />
        </span>
      ),
      key: '3',
      children: helpCenterItems,
    },
    {
      label: (
        <span className='nav-profile-item' onClick={() => handleModal('logout')}>
          <LogOutIcon />
          Log Out
        </span>
      ),
      key: '4',
    },
  ];

  return (
    <>
      <Dropdown
        open={dropdownAndMiscStates.profileDropdownOpen}
        menu={{ items }}
        trigger={['click']}
        destroyOnHidden
        overlayClassName='profile-dropdown-overlay'
      >
        <div className='profile'>
          <ProfileIcon />
          <span className='name'>{name || 'loading..'}</span>
          <DownCaretIcon />
        </div>
      </Dropdown>
      <LogoutModal isOpen={modalData.logout} onClose={closeModal} />
      {modalData.faq && <FAQ isOpen={modalData.faq} onClose={closeModal} product={product} />}
    </>
  );
}

export default Profile;
